(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["button"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__mwtBuyOnceBound) return;
    window.__mwtBuyOnceBound = true;
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form.classList || !form.classList.contains('mwt-buy-form')) return;
      event.preventDefault();
      var idInput = form.querySelector('[name="id"]');
      if (!idInput || !idInput.value) return;
      var submitButton = form.querySelector('[type="submit"]');
      var discountEl = form.querySelector('[data-buy-discount]');
      var code = discountEl && discountEl.getAttribute('data-buy-discount');
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var updates = {};
      updates[idInput.value] = 1;
      fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
        .then(function () {
          if (!code) return;
          return fetch(root + 'discount/' + encodeURIComponent(code) + '?redirect=/cart.js', {
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          });
        })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          var drawer = document.querySelector('#cart-drawer');
          if (drawer && drawer.show) drawer.show();
        })
        .catch(function () {})
        .finally(function () {
          if (submitButton) submitButton.removeAttribute('aria-busy');
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
